module.exports = __webpack_public_path__ + "img/createAgent1.961fcb08.svg";